<template>
<transition :name="transition">
    <div class="_modal" v-if="open" ref="modal">
        <div class="_modal-header">
            <div class="_modal-header-back__btn" @click="open = false">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M15.7071 21.7071C15.3166 22.0976 14.6834 22.0976 14.2929 21.7071L5.29289 12.7071C4.90237 12.3166 4.90237 11.6834 5.29289 11.2929L14.2929 2.29289C14.6834 1.90237 15.3166 1.90237 15.7071 2.29289C16.0976 2.68342 16.0976 3.31658 15.7071 3.70711L7.41421 12L15.7071 20.2929C16.0976 20.6834 16.0976 21.3166 15.7071 21.7071Z"
                        fill="#252628" />
                </svg>
            </div>
            <div class="_modal-header-title">
                <slot name="header"></slot>
            </div>
            <div class="_modal-close__btn" @click="open = false">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M3.99992 4.00017C4.39045 3.60964 5.02361 3.60964 5.41414 4.00017L11.7782 10.3643L18.1421 4.00046C18.5326 3.60994 19.1657 3.60994 19.5563 4.00046C19.9468 4.39098 19.9468 5.02415 19.5563 5.41467L13.1925 11.7785L19.5563 18.1423C19.9468 18.5328 19.9468 19.166 19.5563 19.5565C19.1657 19.947 18.5326 19.947 18.1421 19.5565L11.7782 13.1927L5.41414 19.5568C5.02361 19.9473 4.39045 19.9473 3.99992 19.5568C3.6094 19.1663 3.6094 18.5331 3.99992 18.1426L10.364 11.7785L3.99992 5.41438C3.6094 5.02386 3.6094 4.39069 3.99992 4.00017Z"
                        fill="#252628" />
                </svg>
            </div>
        </div>
        <div class="_modal-body">
            <slot name="body"></slot>
        </div>
    </div>
</transition>
</template>

<script>
export default {
    name: "Modal",
    props: {},
    data() {
        return {
            open: false,
        };
    },
    mounted() { },
    computed: {},
    methods: {
        openModal() {
            this.open = true;
        },
        closeModal() {
            this.open = false;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../styles/mixin/typography";

._modal {
    align-items: center;
    height: 100vh;
    height: 100dvh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 311;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    overflow-y: hidden;

    &.dark-mode {
        background-color: #252628;
        ._modal-header {
            background-color: #252628;
        }

        ._modal-body {
            background: linear-gradient(180deg, rgba(50, 50, 50, 0.05) 0%, rgb(37, 38, 40) 100%);
            background-color: #252628;
        }
        ._modal-header-title {
            color: #fff;
        }
        :is(._modal-header-back__btn, ._modal-close__btn) svg path {
            fill: #fff
        }
    }

    @media(min-width: 1225px) {
        display: none;
    }

    &-close__btn {
        cursor: pointer;
        display: flex;
        align-items: center;
    }

    &-header {
        @include gilroy-600;
        color: #252628;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px;
        font-size: 16px;
        line-height: 24px;
        width: 100%;

        &-back__btn {
            cursor: pointer;
            display: flex;
            align-items: center;
            margin-right: 16px;
        }

        &-title {
            flex: 1;
        }
    }

    &-body {
        padding: 32px 16px;
        background: linear-gradient(180deg,
                rgba(50, 50, 50, 0.05) 0%,
                rgba(255, 255, 255, 1) 100%);
        overflow-y: auto;
        width: 100%;
        height: 100%;
    }
}

.fade {
    &-enter-active {
        // transition: all 0.15s ease;
    }

    &-leave-active {
        // transition: all 0.15s ease;
    }

    &-enter-from {
        // transform: translate(-50%, -24px);
    }

    &-enter-to {
        // opacity: 1;
        // visibility: visible;
        // transform: translate(-50%, 0);
    }

    &-leave-to {
        // opacity: 0;
        // visibility: hidden;
        // transform: translate(-50%, -24px);
    }
}
</style>
